import { render, staticRenderFns } from "./ArticleIncludedIn.vue?vue&type=template&id=35ad676f&scoped=true&"
import script from "./ArticleIncludedIn.vue?vue&type=script&lang=js&"
export * from "./ArticleIncludedIn.vue?vue&type=script&lang=js&"
import style0 from "./ArticleIncludedIn.vue?vue&type=style&index=0&id=35ad676f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad676f",
  null
  
)

export default component.exports